export const classNames = {
  base: 'dw-tag',
  active: 'dw-tag--active',
  disabled: 'dw-tag--disabled',
  input: 'dw-tag--input',
};
